import withPageHandler from '~pricing/hocs/withPageHandler';
import PricingSummary from './Summary';
import PricingDetails from './Details';
import EnterprisePage from './Enterprise';
import EducationalPage from './Educational';

export default [
  {
    component: withPageHandler(PricingSummary),
    paths: [
      '/pricing',
      '/pricing/',
      '/pricing/upgrade/',
      '/pricing/upgrade/quickview/',
      '/pricing/:canonicalPath(individual|teams)',
    ],
  },
  {
    component: withPageHandler(EnterprisePage),
    paths: ['/pricing/:canonicalPath(enterprise)/:subPath(details)?'],
  },
  {
    component: withPageHandler(PricingDetails),
    paths: ['/pricing/:canonicalPath(details|individual|teams)?/:subPath(details)'],
  },
  {
    component: withPageHandler(EducationalPage),
    paths: ['/pricing/:canonicalPath(educational)'],
  },
];
